import { DownloadFile } from "../../../Utils/helpers";
import ApiClient from "../api-client";
import { EnvType } from "../services";
import { DbKdmRecipientInfos } from "../Types/db-kdm-recipient-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { KdmListResponse } from "../Types/kdm-list-response";
import { default as DciApiClient, default as IDciApiClient } from "./dci-api-client";

export default class DciService {
  dciApiClient: IDciApiClient;

  constructor(envType: EnvType) {
    this.dciApiClient = new DciApiClient(new ApiClient(envType), envType);
  }

  async UploadDkdm(
    objectId: number,
    fileToUpload: File,
    abortSignal?: AbortSignal,
    onUploadProgressCallback?: (progressEvent: any) => void
  ): Promise<GenericResponseStd> {
    return this.dciApiClient.UploadDkdm(objectId, fileToUpload, abortSignal, onUploadProgressCallback);
  }

  async ListKdmRecipients(): Promise<KdmListResponse> {
    return this.dciApiClient.ListKdmRecipients();
  }

  DownloadKdmRecipientCert(objectId: number): string {
    return this.dciApiClient.DownloadKdmRecipientCert(objectId);
  }

  async DownloadKdmPublicCert(): Promise<boolean> {
    const [fileData, headers] = await this.dciApiClient.DownloadKdmPublicCert();

    if (!fileData || fileData.length === 0) return false;
    const headerContentDisp = headers["content-disposition"];
    let fileName = `mediaspot_public_dci_certificate.pem`;
    const headerStartsWith = "attachment; filename=";
    if (headerContentDisp && headerContentDisp.includes(headerStartsWith)) {
      const split = headerContentDisp.substring(headerStartsWith.length).split(";");
      fileName = split[0];
    }

    DownloadFile(fileData, "text/octet-stream", fileName);

    return true;
  }

  async CreateKdmRecipient(request: DbKdmRecipientInfos): Promise<GenericResponseStd> {
    return this.dciApiClient.CreateKdmRecipient(request);
  }

  async UpdateKdmRecipient(request: DbKdmRecipientInfos): Promise<GenericResponseStd> {
    return this.dciApiClient.UpdateKdmRecipient(request);
  }

  async DeleteKdmRecipient(objectId: number): Promise<GenericResponseStd> {
    return this.dciApiClient.DeleteKdmRecipient(objectId);
  }

  async SyncKdmRecipients(): Promise<GenericResponseStd> {
    return this.dciApiClient.SyncKdmRecipients();
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.dciApiClient.GetApiUrl();
  }
}
